import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDeviceSelectors } from 'react-device-detect';
import { useNavigate, useSearchParams } from 'react-router';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import Loader from '../../../components/base/Loader/Loader';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  authorizedLogout,
  callCallbackEsia, getProfileCompanies, setCompany,
} from '../actions';
import { responseLogWithNotification } from '../../../utils/utils';
import { getAuthorizedData } from '../reducer';
import { calculateBaseRoute } from '../../../utils/routeByRoles';

export default function EsiaCallback() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const state = searchParams.get('state');
  const errorCode = searchParams.get('error-code');
  const errorMessage = searchParams.get('error-message');
  const [selectors] = useDeviceSelectors(window.navigator.userAgent);
  const {
    loginProcess,
    loadingForgotPassword,
    loadingRedirectUrl,
    loadingEsiaRedirectUrl,
    loadingSetCompany,
    loadingProfileCompanies,
    profileCompaniesList,

  } = useSelector(getAuthorizedData);
  const { formatMessage } = useIntl();

  useEffect(() => {
    const data = { state };
    if (errorCode) {
      data['error-code'] = errorCode;
    }
    if (errorMessage) {
      data['error-message'] = errorMessage;
    }

    dispatch(callCallbackEsia(data))
      .then(() => {
        dispatch(getProfileCompanies(data))
          .catch(response => {
            setError(response?.message || '');
            responseLogWithNotification(response, formatMessage({ id: 'app.login' }), formatMessage({ id: 'error.default' }));
          });
        setError('');
      })
      .catch(response => {
        setError(response?.message || '');
        responseLogWithNotification(response, formatMessage({ id: 'app.login' }), formatMessage({ id: 'error.default' }));
      });
  }, []);
  const loading = loginProcess || loadingForgotPassword || loadingRedirectUrl || loadingEsiaRedirectUrl || loadingSetCompany || loadingProfileCompanies;

  const handleSelectCompany = id => {
    setSelectedCompany(id);
    dispatch(setCompany(id))
      .catch(response => {
        setError(response?.message || '');
        responseLogWithNotification(response, formatMessage({ id: 'app.login' }), formatMessage({ id: 'error.default' }));
      });
  };

  const handleLogout = () => {
    dispatch(authorizedLogout())
      .then(data => {
        setTimeout(() => { window.location.href = data?.logoutUrl || '/'; }, 100);
      })
      .catch(response => {
        responseLogWithNotification(response, formatMessage({ id: 'app.logout' }), formatMessage({ id: 'error.default' }));
      });
  };

  return (
    <>
      <Loader loading={loading} />
      <div className="login-page-wrapper">
        <div className="login-page">
          <div className="login-logo">
            <Icons customIcon icon="logo-full" />
          </div>
          {!error && !loading ? (
            <div className="form-block-profile">
              <div className="profile-list-header">Войти как</div>
              {profileCompaniesList.map((item, index) => (
                <div
                  key={`profile-${index}`}
                  className={classNames('profile-block', { selected: selectedCompany === item.value })}
                  onClick={() => handleSelectCompany(item.value)}
                >
                  <div className="profile-avatar">
                    <Icons customIcon icon="avatar" />
                  </div>
                  <div className="profile-info">
                    <div className="profile-name">{item.label}</div>
                    <div className="profile-type">{item.type}</div>
                  </div>
                </div>
              ))}
              <div className="w-100 text-center">
                <Button variant="secondary" className="exit-button" onClick={handleLogout}>
                  Выйти
                </Button>
              </div>
            </div>
          ) : null}
          {error ? (
            <div className="form-block-wrapper">
              <div className="form-block">
                <div className="login-block">
                  <div className="login-error-header f3 w-100 text-center">Ошибка</div>
                  <div className="mt-3 mb-3 w-100 text-center">{error}</div>
                  <div className="text-center w-100">
                    <Button
                      className="big"
                      onClick={() => {
                        navigate('/');
                      }}
                    >
                      {formatMessage({ id: 'back.to.main' })}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}
